import styled from "styled-components";

export const Header = styled.div`
  margin-bottom: 16px;
  display: Flex;
  justify-content: flex-end;
`;

export const ModalTitle = styled.h2`
  color: #031795;
  fontweight: bold;
  fontsize: 20px;
  text-align: center;
  width: 60%;
`;

export const HeaderCloseButton = styled.span`
  position: absolute;
  right: 20px;
  cursor: pointer;
`;

export const ModalContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

export const ConcludeButtonContainer = styled.div`
  display: flex;
  align-items: center;  
  justify-content: center;

  width: 100%;

  margin-bottom: 12px;
  margin-top: 26px;

  button + button{
    margin-left: 6px;
  }
`;
